import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'Logo',
  description: '',
  categories: [],
  props: t.object({
    style: t.choice(['allWhite', 'standard']).optional()
  }),
  examples: {
    basic: {
      props: {
      },
      description: ''
    }
  },
  todo: [],
})
